import React, { useEffect } from "react";
import { useHistory, useParams } from "react-router-dom";
import { Box, Typography, CircularProgress } from "@mui/material";
import { CheckCircle } from "@mui/icons-material";
import { useBypassToken } from "../../hooks/useBypassToken";
import authService from "../../../services/authService";

const FormCompletionPage: React.FC = () => {
  const history = useHistory();
  const { formId } = useParams<{ formId: string }>();
  const { type } = useBypassToken();
  const isInOffice = type === 'inOfficeForms';
  const isPatientForms = type === 'staffAccessForms';
  const fromWeb = [isInOffice, isPatientForms].some(Boolean);

  useEffect(() => {
    if (fromWeb) { // Redirect to dashboard after 3 seconds
      const timer = setTimeout(() => {
        authService.cleanAuth();
        if (isPatientForms) {
          window.close();
        }
      }, 3000);

      return () => clearTimeout(timer);
    } else {
      const timer = setTimeout(() => {
        history.push("/patientDashboardPage");
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [history, type]);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
        textAlign: "center",
        p: 3,
      }}
    >
      <CheckCircle
        sx={{
          fontSize: 80,
          color: "success.main",
          mb: 3,
        }}
      />
      <Typography variant="h4" component="h1" gutterBottom>
        Form Submitted Successfully!
      </Typography>
      <Typography variant="body1" color="text.secondary" paragraph sx={{ maxWidth: "600px" }}>
        Thank you for completing the form. {
          isInOffice
            ? 'Please hand this device back to the staff member in order to complete your pre-appointment check in.'
            : isPatientForms
              ? 'You will be closed out of this tab shortly.'
              : 'You will be redirected to the patient dashboard shortly.'
        }
      </Typography>
      {!fromWeb && <CircularProgress size={24} sx={{ mt: 2 }} />}
    </Box>
  );
};

export default FormCompletionPage;
